import Trix from 'trix'

export const colors = [
  { name: 'Light Blue', value: 'lightblue' },
  { name: 'Red', value: 'red' },
  { name: 'Dark Blue', value: 'darkblue' },
  { name: 'Purple', value: 'purple' },
  { name: 'Orange', value: 'orange' },
  { name: 'Green', value: 'green' },
  { name: 'Fuchsia', value: 'fuchsia' },
  { name: 'Turquoise', value: 'turquoise' },
  { name: 'Black', value: 'black' }
]

export function initTrixColorAttributes() {
  if (!Trix?.config?.textAttributes) {
    console.error("Trix configuration not ready for color attributes")
    return
  }

  Trix.config.dompurify.ADD_TAGS = colors.map(color => color.value)

  colors.forEach(({ value }) => {
    Trix.config.textAttributes[value] = {
      tagName: value,
      className: `trix-color-${value}`,
      inheritable: true
    }
  })
}

export function generateColorPickerHTML(editorId) {
  return `
    <div class="color-picker-wrapper" data-trix-color-picker="${editorId}" style="display: none;">
      ${colors.map(color => `
        <label class="color-picker" data-trix--colours-target="colour">
          <input type="radio" name="foregroundColor" data-trix-attribute="${color.value}" value="${color.value}" data-color-picker-input>
          <span class="swatch ${color.value}" style="color: ${color.value}"></span>
        </label>
      `).join('')}
    </div>
    <button type="button" class="trix-button trix-button--color-picker" data-color-picker-button title="Colours">
      <span class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.847 21.934C5.867 21.362 2 17.133 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.157 18.717 16.733 15.914 16.37C14.296 16.161 12.839 15.973 12.262 16.888C11.867 17.514 12.294 18.294 12.817 18.817C12.9724 18.9724 13.0956 19.1568 13.1797 19.3598C13.2637 19.5627 13.307 19.7803 13.307 20C13.307 20.2197 13.2637 20.4373 13.1797 20.6402C13.0956 20.8432 12.9724 21.0276 12.817 21.183C12.294 21.706 11.582 22.019 10.847 21.934ZM11.085 7C11.085 7.39782 10.927 7.77936 10.6457 8.06066C10.3644 8.34196 9.98282 8.5 9.585 8.5C9.18718 8.5 8.80564 8.34196 8.52434 8.06066C8.24304 7.77936 8.085 7.39782 8.085 7C8.085 6.60218 8.24304 6.22064 8.52434 5.93934C8.80564 5.65804 9.18718 5.5 9.585 5.5C9.98282 5.5 10.3644 5.65804 10.6457 5.93934C10.927 6.22064 11.085 6.60218 11.085 7ZM6.5 13C6.89782 13 7.27936 12.842 7.56066 12.5607C7.84196 12.2794 8 11.8978 8 11.5C8 11.1022 7.84196 10.7206 7.56066 10.4393C7.27936 10.158 6.89782 10 6.5 10C6.10218 10 5.72064 10.158 5.43934 10.4393C5.15804 10.7206 5 11.1022 5 11.5C5 11.8978 5.15804 12.2794 5.43934 12.5607C5.72064 12.842 6.10218 13 6.5 13ZM17.5 13C17.8978 13 18.2794 12.842 18.5607 12.5607C18.842 12.2794 19 11.8978 19 11.5C19 11.1022 18.842 10.7206 18.5607 10.4393C18.2794 10.158 17.8978 10 17.5 10C17.1022 10 16.7206 10.158 16.4393 10.4393C16.158 10.7206 16 11.1022 16 11.5C16 11.8978 16.158 12.2794 16.4393 12.5607C16.7206 12.842 17.1022 13 17.5 13ZM14.5 8.5C14.697 8.5 14.892 8.4612 15.074 8.38582C15.256 8.31044 15.4214 8.19995 15.5607 8.06066C15.6999 7.92137 15.8104 7.75601 15.8858 7.57403C15.9612 7.39204 16 7.19698 16 7C16 6.80302 15.9612 6.60796 15.8858 6.42597C15.8104 6.24399 15.6999 6.07863 15.5607 5.93934C15.4214 5.80005 15.256 5.68956 15.074 5.61418C14.892 5.5388 14.697 5.5 14.5 5.5C14.1022 5.5 13.7206 5.65804 13.4393 5.93934C13.158 6.22064 13 6.60218 13 7C13 7.39782 13.158 7.77936 13.4393 8.06066C13.7206 8.34196 14.1022 8.5 14.5 8.5Z" fill="#1F040F"/>
        </svg>
      </span>
    </button>`
}

function findActiveEditor(clickedElement) {
  const closestTrixEditor = clickedElement.closest('.wysiwyg-wrapper')?.querySelector('trix-editor')
    || clickedElement.closest('trix-editor')
  return closestTrixEditor?.editor
}

function handleColorPickerButtonClick(event) {
  const button = event.target.closest('[data-color-picker-button]')
  if (!button) return

  event.preventDefault()
  event.stopImmediatePropagation()

  const picker = button.previousElementSibling
  if (picker && picker.classList.contains('color-picker-wrapper')) {
    const isHidden = picker.style.display === 'none' || !picker.style.display
    picker.style.display = isHidden ? 'flex' : 'none'
    void picker.offsetHeight
  }
}

function handleColorSelection(event) {
  const input = event.target.closest('[data-color-picker-input]')
  if (!input) return

  event.preventDefault()
  event.stopPropagation()

  const editor = findActiveEditor(event.target)
  if (!editor) {
    console.error("No active Trix editor found")
    return
  }

  const picker = input.closest('.color-picker-wrapper')
  const selectedColor = input.value
  const currentSelection = editor.getSelectedRange()

  if (editor && picker) {
    const isActive = editor.composition.getCurrentAttributes()[selectedColor] === true

    if (isActive) {
      editor.deactivateAttribute(selectedColor)
    } else {
      colors.forEach(({ value }) => {
        if (value !== selectedColor) {
          editor.deactivateAttribute(value)
        }
      })
      editor.activateAttribute(selectedColor)
    }

    picker.style.display = 'none'
    void picker.offsetHeight
    editor.setSelectedRange(currentSelection)
    editor.element.focus()
  }
}

function updateBrushButtonState(editor) {
  const wrapper = editor.element.closest('.wysiwyg-wrapper')
  const brushButton = wrapper?.querySelector('[data-color-picker-button]')
  if (!brushButton) return

  const [start, end] = editor.getSelectedRange()
  const hasSelection = start !== end

  if (!hasSelection) {
    const currentAttributes = editor.composition.getCurrentAttributes()
    const activeColor = colors.find(({ value }) => currentAttributes[value])
    brushButton.classList.toggle('trix-active', !!activeColor)
    return
  }

  const commonAttributes = editor.getDocument().getCommonAttributesAtRange([start, end])
  const activeColor = colors.find(({ value }) => commonAttributes[value])

  brushButton.classList.toggle('trix-active', !!activeColor)
}

export function setupColorPickerHandlers() {
  // Remove from both capture and bubble phases to ensure clean state
  document.removeEventListener('click', handleColorPickerButtonClick, true)
  document.removeEventListener('click', handleColorSelection, true)
  document.removeEventListener('click', handleColorPickerButtonClick, false)
  document.removeEventListener('click', handleColorSelection, false)

  // Add with capture phase (true = capture, runs before bubble)
  document.addEventListener('click', handleColorPickerButtonClick, true)
  document.addEventListener('click', handleColorSelection, true)

  document.addEventListener('turbo:before-cache', function () {
    document.querySelectorAll('.color-picker-wrapper').forEach(picker => {
      picker.style.display = 'none'
    })
  })

  document.addEventListener('trix-selection-change', function (event) {
    if (event.target.tagName !== 'TRIX-EDITOR') return
    const editor = event.target.editor
    if (editor) updateBrushButtonState(editor)
  })

  document.addEventListener('trix-change', function (event) {
    if (event.target.tagName !== 'TRIX-EDITOR') return
    const editor = event.target.editor
    if (editor) updateBrushButtonState(editor)
  })
}
